export default "__VITE_ASSET__58421134__"